// DO NOT EDIT manually
// This file has edited by setConfig.sh file

// version : web version (from package.json)
// build time : time the build was performed
// build commit : Commit value of GIT

export default {
    version: '1.5.10',
    build_time: '2026-08-26T07:27:20',
    build_commit_hash: '5307c008e9836b16a8f5dcfc3373664466aad3f8',
};
